import './card.scss';import Sloth from '../Sloth';


/** WEBPACK FOOTER **
 ** ./components/Card/card.js
 **/